export function ProductItem(product) {
    const $product = document.createElement('div');
    $product.className = 'product';

    $product.dataset.productId = product.id;

    if (!product.image_url) {
        product.image_url = '/public/assets/images/product-default.jpg';
    }

    let cost
    if (product.cost) {
        cost = '&pound;' + (product.cost / 100).toFixed(2);
    } else {
        cost = 'Free';
    }

    $product.innerHTML = `
        <img src="${product.image_url}" alt="${product.name}"/>
        <div class="info">
            <h2>${product.name} <span class="cost">${cost}</span></h2>
        </div>
        <div class="buttons">
            <a href="/shop/product/${product.id}"><button title="View Item">View</button></a>
            <button class="AddBasket" title="Add to Basket">Add</button>
        </div>
    `;

    return $product;
}
